let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("tpYwC")).then(() => parcelRequire('cn7RC'));